import { Link } from 'react-router-dom';
import { DocSection, kbd } from '../../../pages/shell';
import { DocShot } from '../../DocShot';

export const toc = [
  { id: 'uninstall-app', label: 'Uninstall the app' },
  { id: 'whats-left', label: "What's left behind" },
  { id: 'remove-data', label: 'Remove your analysis data & models' },
  { id: 'remove-panel', label: 'Remove the Premiere panel' },
];

export default function Body() {
  return (
    <>
      <DocSection id="uninstall-app" title="Uninstall the app">
        <p>
          ClipRadar installs and uninstalls like any other Windows app. Quit it first —
          right-click the tray icon and choose <strong>Quit ClipRadar</strong> — then open{' '}
          <strong>Settings &rarr; Apps &rarr; Installed apps</strong> (or{' '}
          <strong>Control Panel &rarr; Programs and Features</strong> on older Windows), find{' '}
          <strong>ClipRadar</strong>, and choose <strong>Uninstall</strong>.
        </p>
        <DocShot slug="uninstall" shot="add-remove" alt="ClipRadar listed in Windows' Installed apps with the Uninstall option" />
      </DocSection>

      <DocSection id="whats-left" title="What's left behind">
        <p>
          Uninstalling only removes the app itself — your data stays put, the same way a browser
          keeps your bookmarks after an update. Everything ClipRadar wrote lives under{' '}
          <span style={kbd}>%APPDATA%\ClipRadar</span>: your downloaded models, your license, your
          analysis cache (thumbnails, embeddings, transcripts, faces) for every file
          you&rsquo;ve indexed, and its logs. Reinstalling ClipRadar picks all of that back up —
          your license reactivates and your library doesn&rsquo;t need re-analyzing.
        </p>
        <DocShot slug="uninstall" shot="appdata" alt="File Explorer open on the %APPDATA%\ClipRadar folder" />
      </DocSection>

      <DocSection id="remove-data" title="Remove your analysis data & models">
        <p>
          For a completely clean slate, delete the <span style={kbd}>%APPDATA%\ClipRadar</span>{' '}
          folder yourself (type <span style={kbd}>%APPDATA%</span> into File Explorer&rsquo;s
          address bar to jump there). That clears your license activation, the downloaded models,
          and every file&rsquo;s analysis cache — a fresh install re-downloads the models and
          you&rsquo;ll need to re-analyze your footage and reactivate your license. Your actual
          video and image files are never touched; only ClipRadar&rsquo;s index of them lives in
          that folder.
        </p>
        <p>
          If you moved the Cache folder to a different drive from{' '}
          <Link to="/docs/interface/settings">Settings &rarr; Storage</Link>, delete that folder
          too — it isn&rsquo;t inside <span style={kbd}>%APPDATA%</span>.
        </p>
      </DocSection>

      <DocSection id="remove-panel" title="Remove the Premiere panel">
        <p>
          The <Link to="/docs/platforms/premiere-panel">Premiere panel</Link> is a separate Adobe
          extension (the <span style={kbd}>.ccx</span>) installed through Creative Cloud or the
          ZXP/UXP Installer, not part of the ClipRadar installer — uninstalling the app
          doesn&rsquo;t remove it from Premiere Pro. Remove it the same way you&rsquo;d remove any
          extension in whichever tool you used to install it: the ZXP/UXP Installer, or Creative
          Cloud&rsquo;s extension manager.
        </p>
      </DocSection>
    </>
  );
}
